<template>
  <div class="activity">
    <div class="activity-top">
      <DActivityAvatar :activity="activity" />

      <div class="activity-title">
        <DActivityAuthor :activity="activity" />

        <span>
          imported
          {{ activity.extra.total }} {{ activity.extra.total | duiPluralize('book', 'books') }}
          to
          <span v-if="!!activity.is_owner">your</span>
          <span v-else>their</span>
          Library
        </span>

        <DActivityTimestamp
          :activity="activity"
          class="visible-until-sm"
        />
      </div>

      <DActivityTimestamp
        :activity="activity"
        class="hidden-until-md"
      />

      <DActivityActions
        v-if="isUserSignedIn && !isRepost"
        :activity="activity"
        @activity-removed="activityRemoved"
      />
    </div>

    <div class="book-previews-wrapper">
      <div class="book-previews">
        <a
          v-for="(book) in activity.extra.books"
          :key="book.slug"
          :href="getBookUrl(book.slug)"
          :title="book.title"
          class="book-preview"
          @click.stop
        >
          <img
            :src="book.covers.medium || book.covers.large || book.covers.small"
            :alt="book.title"
          >
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import activityMixin from '../shared/activity-mixin';
import URLS from '@d-shared/urls/urls';

export default {
  mixins: [
    activityMixin,
  ],
  methods: {
    getBookUrl(slug) {
      return URLS.app.book.replace('<book-slug>', slug);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.activity {
  .book-previews-wrapper {
    @include horizontalNavMenu(white, false);
  }

  .book-previews {
    display: flex;
    margin-bottom: $_2em;
    padding-right: $_8em;
    overflow-x: auto;

    .book-preview {
      box-sizing: border-box;
      flex-shrink: 0;
      margin-right: $_1-5em;
      width: $book-cover-width-xs;
      height: $book-cover-height-xs;

      &:first-child {
        margin-left: $_1-5em;
      }

      &:last-child {
        width: calc(#{$book-cover-width-xs} + #{$_4em});
        padding-right: $_4em;
        margin-right: 0;
      }
    }

    & img {
      box-shadow: $box-shadow-sm;
      border-radius: $_1em;
      display: block;
      height: 100%;
      object-fit: cover;
      width: 100%;
    }
  }
}
</style>
